import React from 'react';
import { ContentCard, BYOButton } from '@cdm/quickenloans-library/lib';
import PropTypes from 'prop-types';
import Icon from './icon/icon';
import { testAttributes } from '../../../../Constants';
import * as Classes from './card.module.scss';
import LearningCenterSourceIdLink from '../../../../../LearningCenterSourceIdLink';

const Card = ({ item, index, articleId = null }) => (
    <ContentCard
        className={Classes.card}
        testId={`${testAttributes.MULTIPLE_CTA_CARD}-${index}`}
    >
        <div className={Classes.header}>
            <div className={Classes.background} />
            <Icon id={item.id} alt={item.title} />
        </div>
        <div className={Classes.content}>
            <div className={Classes.body}>
                <h3 className={Classes.title}>{item.title}</h3>
                <p className={Classes.subtitle}>{item.subtitle}</p>
            </div>
            <div className={Classes.footer}>
                <BYOButton
                    as={LearningCenterSourceIdLink}
                    href={item.url}
                    articleId={articleId}
                    color="green"
                    testId={testAttributes.MULTIPLE_CTA_BUTTON}
                    iconTestId={testAttributes.MULTIPLE_CTA_BUTTON_ICON}
                    // eslint-disable-next-line react/style-prop-object
                    style="filled"
                    {...{ target: '_blank' }}
                    className={Classes.button}
                >
                    {item.ctaButtonText}
                </BYOButton>
            </div>
        </div>
    </ContentCard>
);

export default Card;
Card.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        ctaButtonText: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }),
    index: PropTypes.number,
    articleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
